// AUTHOR: NANDHAKUMAR
// VERSION: 0.0.1
// LAST EDIT: NANDHAKUMAR
// DATE: 17/09/2025
// DESCRIPTION: QR REPORT PAGE SERVICES
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';
/************* FETCH QR REPORT LIST START ******************* */
export const fetchQrReport = (fetchData: any) => {
	const data = {
		QRPaymentReportToken: fetchData,
	};
	const url = `${API_URL}getQRPaymentReport`;
	return makeApiCall(url, data);
};
/************* FETCH QR REPORT LIST END ******************* */
